export const OPEN_AI_ASSISTANT_EVENT = 'redevicer:open-ai'

export function openAiAssistant(): void {
  window.dispatchEvent(new CustomEvent(OPEN_AI_ASSISTANT_EVENT))
}
